import { VenueMapBase } from 'features/venueMap/pages/VenueMap/VenueMapBase'

export const VenueMap = VenueMapBase
